<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/contact" />
          <div class="mainbody">
            <div class="contactcont02">
              <div class="contacttext">
                <h4 class="contitle">合肥信悦信息科技有限公司</h4>
                <p class="context">HEFEI XINYUE TECHNOLOGY CO., LTD.</p>
              </div>
              <ul class="contactmess clearfix"><li><p><span class="conaddressicon conaddress">&nbsp;</span></p><p>公司地址</p><p class="contactmesstext">安徽省合肥市高新区望江西路900号中安创谷科技园二期K4楼4层403单元</p></li>
                <li><p><span class="conaddressicon conphone">&nbsp;</span></p><p>联系电话</p><p class="contactmesstext">0551-65357068</p></li>
                <li><p><span class="conaddressicon conchuanz">&nbsp;</span></p><p>公司传真</p><p class="contactmesstext">----------</p></li>
                <li><p><span class="conaddressicon conemail">&nbsp;</span></p><p>邮政编码</p><p class="contactmesstext">230000</p></li>
                <li><p><span class="conaddressicon conehezuo">&nbsp;</span></p><p>商务合作</p><p class="contactmesstext">15357252383</p></li>
                <li><p><span class="conaddressicon conemeida">&nbsp;</span></p><p>公司网站</p><p class="contactmesstext">http://xy-info.com/</p></li></ul>
              <div class="conmap">
                <iframe :src="baseApi + 'map.html'"></iframe>
              </div>
              <br/><br/><br/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/us/componets/Banner'
import Tab from '@/views/us/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/us/contact.vue